import { render, staticRenderFns } from "./AreaChart1.vue?vue&type=template&id=5877c428&scoped=true"
import script from "./AreaChart1.vue?vue&type=script&lang=js"
export * from "./AreaChart1.vue?vue&type=script&lang=js"
import style0 from "./AreaChart1.vue?vue&type=style&index=0&id=5877c428&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5877c428",
  null
  
)

export default component.exports